export const TEMPLATE_CATEGORY_IDS = {
  DESIGN_PROFESSIONAL: "7e80126d-083b-40a0-b0ed-baf92eeaf4ee",
  FEE_SIMPLE: "dd01e0c5-5ee4-4d42-b46e-8eb61e0deab6",
  BONDING: "7f26a819-c2ac-4a6d-866e-6500bc9b69c8",
  MORTGAGE: "d3f81ed2-b564-48d7-bd38-60f014853a0c",
};

export const TEMPLATE_CATEGORY_CONFIG = {
  [TEMPLATE_CATEGORY_IDS.DESIGN_PROFESSIONAL]: {
    label: "Design Professional",
    selectorName: "designProfessional",
    selectLabel: "Select Design Professional",
    listKey: "designProfessional",
    displayFields: ["companyName", "design_pro_company", "licenseNumber"],
    addingState: "addingNewDesignPro",
    loadingState: "designProLoading",
    removeModalState: "addDesignProConfirmOpen",
    aliases: {
      design_pro_company: ["design_pro_company", "companyName"],
      design_pro_license_name: ["design_pro_license_name", "licenseName"],
      design_pro_license_num: ["design_pro_license_num", "licenseNumber"],
      design_pro_address: ["design_pro_address", "address", "fullAddress"],
      design_pro_street: ["design_pro_street", "street", "address1"],
      design_pro_city: ["design_pro_city", "city"],
      design_pro_state: ["design_pro_state", "state"],
      design_pro_zip: ["design_pro_zip", "zip", "zipCode"],
      design_pro_phone: ["design_pro_phone", "phone", "mobile"],
      design_pro_fax: ["design_pro_fax", "fax"],
      design_pro_email: ["design_pro_email", "email"],
    },
  },
  [TEMPLATE_CATEGORY_IDS.FEE_SIMPLE]: {
    label: "Fee Simple Details",
    selectorName: "feeSimpleTitleholder",
    selectLabel: "Select Fee Simple Title Holder Contact",
    listKey: "feeSimple",
    displayFields: ["fee_simple_name"],
    addingState: "addingNewFeeSimple",
    loadingState: "feeSimpleLoading",
    removeModalState: "feeSimpleConfirmModalOpen",
    aliases: {
      fee_simple_name: ["fee_simple_name", "name"],
      fee_simple_address: ["fee_simple_address", "address", "fullAddress"],
      fee_simple_street: ["fee_simple_street", "street", "address1"],
      fee_simple_city: ["fee_simple_city", "city"],
      fee_simple_state: ["fee_simple_state", "state"],
      fee_simple_zip: ["fee_simple_zip", "zip", "zipCode"],
    },
  },
  [TEMPLATE_CATEGORY_IDS.BONDING]: {
    label: "Bonding Company Details",
    selectorName: "bondingCompany",
    selectLabel: "Select Bonding Company",
    listKey: "bonding",
    displayFields: ["bonding_name"],
    addingState: "addingNewBonding",
    loadingState: "bondingLoading",
    removeModalState: "bondingConfirmModalOpen",
    aliases: {
      bonding_name: ["bonding_name", "name"],
      bonding_address: ["bonding_address", "address", "fullAddress"],
      bonding_street: ["bonding_street", "street", "address1"],
      bonding_city: ["bonding_city", "city"],
      bonding_state: ["bonding_state", "state"],
      bonding_zip: ["bonding_zip", "zip", "zipCode"],
    },
  },
  [TEMPLATE_CATEGORY_IDS.MORTGAGE]: {
    label: "Mortgage Lender's Details",
    selectorName: "mortgageLender",
    selectLabel: "Select Mortgage Lender",
    listKey: "mortgageLender",
    displayFields: ["mortgage_name"],
    addingState: "addingNewMortgage",
    loadingState: "mortgageLoading",
    removeModalState: "mortgageConfirmModalOpen",
    aliases: {
      mortgage_name: ["mortgage_name", "name"],
      mortgage_address: ["mortgage_address", "address", "fullAddress"],
      mortgage_street: ["mortgage_street", "street", "address1"],
      mortgage_city: ["mortgage_city", "city"],
      mortgage_state: ["mortgage_state", "state"],
      mortgage_zip: ["mortgage_zip", "zip", "zipCode"],
    },
  },
};

export const getTemplateCategoryConfig = (categoryId) =>
  TEMPLATE_CATEGORY_CONFIG[categoryId] || null;

export const getTemplateDisplayName = (template, config) => {
  for (const key of config?.displayFields || []) {
    if (template?.[key]) return template[key];
  }
  return "Unnamed";
};

export const buildTemplateFieldValues = (template, fields, config) =>
  (fields || []).reduce((values, field) => {
    const aliases = config?.aliases?.[field?.name] || [field?.name];
    const alias = aliases.find(
      (key) => template?.[key] !== undefined && template?.[key] !== null,
    );
    return alias ? { ...values, [field.name]: template[alias] } : values;
  }, {});
